<template>
  <div class="slider">
    <div class="slider__header">
      <p class="slider__title" :class="{ horizontal }">{{ title }}</p>
      <p class="slider__values" :class="{ horizontal }">
        <span v-if="units === 'm'"
          >{{ horizontal ? `${$t('from')} ` : ''
          }}{{
            Number(value[0])
              .toFixed(fixed)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }}
          {{ units }}<sup>2</sup></span
        >
        <span v-if="units === 'm'"
          >{{ horizontal ? `${$t('to')} ` : ''
          }}{{
            Number(value[1])
              .toFixed(fixed)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }}
          {{ units }}<sup>2</sup></span
        >
        <span v-if="units !== 'm'"
          >{{ horizontal ? `${$t('from')} ` : ''
          }}{{
            Number(value[0])
              .toFixed(fixed)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }}
          {{ units }}</span
        >
        <span v-if="units !== 'm'"
          >{{ horizontal ? `${$t('to')} ` : ''
          }}{{
            Number(value[1])
              .toFixed(fixed)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
          }}
          {{ units }}</span
        >
      </p>
    </div>

    <div class="slider__content">
      <vue-slider
        v-model="value"
        :enable-cross="false"
        :min="min"
        :max="max"
        :key="`${update},${min},${max}`"
        tooltip="none"
        :disabled="false"
        :lazy="lazy || islazy"
        :processStyle="{
          background: '#939498',
          boxShadow: `0px 0px 6px rgba(0,0,0, 0.1)`,
          height: '8px',
        }"
        :dotStyle="{
          position: 'absolute',
          top: '-4px',
          width: '9px',
          height: '25px',
          backgroundColor: '#D4AA8A',
          boxShadow: `0px 0px 10px rgba(0,0,0, 0.1)`,
          transform: 'translateX(0px)',
          borderRadius: '10px',
        }"
        :railStyle="{
          background: '#ffffff',
          boxShadow: `0px 0px 6px rgba(0,0,0, 0.1)`,
          height: '8px',
        }"
        :silent="true"
        class="slider__range"
      ></vue-slider>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
  data() {
    return {
      value: [-Infinity, Infinity],
      update: false,
    };
  },
  props: [
    'property',
    'title',
    'units',
    'lazy',
    'fixed',
    'horizontal',
    'queryParam',
  ],
  components: {
    VueSlider,
  },
  computed: {
    values() {
      return [
        ...this.$store.getters.GET_FLATS.map(flat =>
          Math.ceil(flat[this.property])
        ),
        ...this.$store.getters.GET_FLATS.map(flat =>
          Math.floor(flat[this.property])
        ),
      ];
    },

    min() {
      // let minimum = Math.min(...this.values);
      // return minimum;
      return 1;
    },
    max() {
      let maximum = Math.max(...this.values);
      return maximum;
    },
    ...mapState({
      filters: state => state.browser.filters,
      islazy: state => state.browser.lazySlider,
    }),
    tooltip() {
      return this.lazy == true ? 'focus' : 'none';
    },
  },
  watch: {
    min(val) {
      this.value[0] = parseInt(val);
      this.loadSlider(this.filters);
    },
    max(val) {
      this.value[1] = parseInt(val);
      this.loadSlider(this.filters);
    },
    value(val) {
      this.updateFilter({ property: this.property, from: val[0], to: val[1] });
    },
    filters(vals) {
      this.loadSlider(vals);
    },
  },
  methods: {
    ...mapMutations({
      updateFilter: 'ADD_FILTERS',
    }),
    resetSlider() {
      this.update = true;
      this.value[0] = parseInt(this.min);
      this.value[1] = parseInt(this.max);
      this.$nextTick(() => {
        this.update = false;
      });
    },
    loadSlider(filters) {
      let props = filters.map(filter => filter.property);
      let fltr = filters.filter(filter => filter.property == this.property)[0];
      if (!props.includes(this.property)) {
        this.resetSlider();
      } else if (fltr.to != this.value[1] || fltr.from != this.value[0]) {
        this.update = true;
        this.value[0] = parseInt(fltr.from);
        this.value[1] = parseInt(fltr.to);
        this.$nextTick(() => {
          this.update = false;
        });
      }
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    },
  },
  created() {
    this.loadSlider(this.filters);
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const initValues = urlParams.get(this.queryParam);
    if (initValues) {
      const min = initValues.split('-')[0];
      const max = initValues.split('-')[1] || min;
      this.updateFilter({ property: this.property, from: min, to: max });
      sessionStorage.setItem(
        `${this.queryParam}-${window.location.href}`,
        true
      );
    }
  },
};
</script>

<style lang="scss">
.slider {
  position: relative;
  width: 100%;
  margin-bottom: 70px;
  max-width: 360px;
  @media screen and (max-width: $xl) {
    margin-bottom: 56px;
  }
  @media screen and (max-width: $xs) {
    margin-bottom: 40px;
  }
}

.slider__title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 15px;
  &.horizontal {
    font-size: 15px;
  }
}
.slider__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.slider__values {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  bottom: -45px;
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 8px;
  &.horizontal {
    bottom: auto;
    top: 0;
    justify-content: flex-end;
    font-size: 14px;
    span:first-child {
      margin-right: 5px;
    }
  }
}

.slider__data {
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 4px;

  color: #000;
  font-size: 14px;
  font-weight: 500;
}
.slider__content {
  position: relative;
  margin: 0 auto;
}

.slider__edge {
  position: absolute;
  top: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  height: 8px;
}

.slider__min {
  @extend .slider__edge;
  left: 0;
  transform: translate(calc(-100% - 10px), -50%);
}

.slider__max {
  @extend .slider__edge;
  right: 0;
  transform: translate(calc(100% + 10px), -50%);
}
</style>
